import { Box, Chip, Typography } from "@mui/material";
import { INoDisponibleLectura } from "../../types/Jornada";
import { textoNoDisponible } from "../../utils/Jornada";

// Un no disponible en solo lectura, en lenguaje claro («Martes 10 nov · 10:00–14:00 (4 h)»), con «En curso» si ya ha
// empezado. Se gestionan en Configuración › Usuarios.
interface NoDisponibleLecturaProps {
    noDisponible: INoDisponibleLectura;
    prefijo?: string;
}

const NoDisponibleLectura = ({ noDisponible, prefijo = '' }: NoDisponibleLecturaProps) => {
    const { texto, enCurso } = textoNoDisponible(noDisponible.start, noDisponible.end);
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
            {enCurso && <Chip size="small" color="warning" label="En curso" />}
            <Typography variant="body2" color="text.secondary">{prefijo}{texto}</Typography>
        </Box>
    );
};

export default NoDisponibleLectura;
